import radius from "../../../assets/images/section2_radius.svg";
import section2_bg1 from "../../../assets/images/section2_bg1.svg";
import section2_bg2 from "../../../assets/images/section2_bg2.svg";
import sweetheart_left from "../../../assets/images/sweetheart-left.svg";
import sweetheart_right from "../../../assets/images/sweetheart-right.svg";
import Container from "../../../components/container";
export default function Section2() {
    return (<div className='min-h-[790px] ssm:min-h-[740px] section2 relative overflow-hidden'
    id="section2"
    >
        <div className="header_bg"></div>
        <div className="header_bg2 left-1/2 transform -translate-x-1/2"></div>
        <div className="relative w-full top-[-20px] flex justify-center items-center overflow-hidden">
            <img src={section2_bg1} alt="section2bg1" className="overflow-hidden w-[1170px] h-[474px] flex-none overflow-hidden object-cover" />
            <img src={section2_bg2} alt="section2bg2" className="absolute top-[39px] overflow-hidden w-[773px] h-[341px] object-cover" style={{ objectFit: 'cover' }} />
        </div>
        <Container >
            <div className="flex flex-col w-full items-center relative top-[-70px]">
                <h4 className="uppercase text-[#96E5AA] text-[24px] md:text-[32px] lg:text-[36px] leading-[30px] md:leading-[40px] lg:leading-[50px] font-bold text-center">Cloud, Mobile and ai<br />
                    Apps solution development</h4>
                <div className="w-full flex justify-between items-center mt-[26px] sm:mt-4">
                    <img src={sweetheart_left} alt="sweetheart_left" className="hidden md:flex" />
                    <p className="text-[#FFFFFF] text-[16px] md:text-[18px] leading-[30px] text-center w-full max-w-[767px] font-normal text-center">We empower businesses with cutting-edge digital solutions tailored to modern needs. Our expertise spans across cloud, mobile, and AI-powered applications, helping companies innovate, scale, and stay ahead in a competitive landscape.</p>
                    <img src={sweetheart_right} alt="sweetheart_right" className="hidden md:flex" />
                </div>
            </div>
        </Container>
        <img src={radius} alt="radius" className="w-[630px] h-[70px] absolute bottom-[-12px] left-1/2 transform -translate-x-1/2 overflow-hidden" />
    </div>);
}